import { isArray, isPlainObject } from 'lodash-es';
import moment, { Moment } from 'moment';

export type JsonPrimitive = null | boolean | number | string | JsonPrimitive[];

export type JsonObject = { [prop: string]: Json };

export type Json = JsonPrimitive | JsonObject | Json[];

export type IPlaceholders = Record<string, JsonObject>;

export function isJsonArray(value: Json | unknown): value is Json[] {
    return !isJsonPrimitiveValue(value) && !isJsonObject(value) && isArray(value);
}

export function isJsonObject(value: unknown): value is JsonObject {
    return isPlainObject(value);
}

export const isJsonPrimitiveValue = (value: unknown): value is JsonPrimitive =>
    typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string' || value === null;

export function tryConvertISODate(value: string): Moment | string {
    const date = moment(value, moment.ISO_8601, true);
    return date.isValid() ? date : value;
}
export const isStringArray = (value: unknown): value is Array<string> =>
    Array.isArray(value) && value.every((item: unknown) => typeof item === 'string');

export const getJsonObjectNestedProp = (obj: JsonObject, path: string[]) => {
    let current: JsonObject | Json[] = obj;
    for (let i = 0; i < path.length; i++) {
        const tmp: Json | JsonObject = isJsonArray(current) ? current[parseInt(path[i])] : current[path[i]];
        if (tmp === undefined) {
            return undefined;
        }
        if (isJsonPrimitiveValue(tmp)) {
            return i === path.length - 1 ? tmp : undefined;
        }
        if (isJsonObject(tmp) || isJsonArray(tmp)) current = tmp;
    }

    return current;
};
